import useAccessClientInfo from './useClientAccessInfo'
import { useEffect, useState } from 'react'

const useFetchAccessClientInfo = () => {
  const { getClientAccessInfo } = useAccessClientInfo()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchClientAccessInfo = async () => {
      setLoading(true)
      setError(null)

      try {
        await getClientAccessInfo()
      } catch (err) {
        setError(err instanceof Error ? err.message : String(err))
      } finally {
        setLoading(false)
      }
    }

    fetchClientAccessInfo()
  }, [])

  return { loading, error }
}

export default useFetchAccessClientInfo
